import { useState, type ReactNode } from 'react'

/**
 * Evidence, folded to one line.
 *
 * The conversation the model read and the documents it drew on are how a
 * suspect draft gets diagnosed — a wrong reply and a blind one look identical
 * until you can see whether the thread was read at all. Both were full cards
 * under every draft, which is a lot of screen for something consulted rarely.
 *
 * The count stays on the closed line because it is the part worth seeing every
 * time: "0 messages" answers the question before the fold is even opened.
 */
export function Fold({
  title,
  count,
  children,
}: {
  title: string
  count: string
  children: ReactNode
}) {
  const [open, setOpen] = useState(false)

  return (
    <div className="fold">
      <button className="fold-head" aria-expanded={open} onClick={() => setOpen(!open)}>
        <span className="fold-chevron" aria-hidden="true">
          {open ? '⌄' : '›'}
        </span>
        {title} <span className="fold-count">{count}</span>
      </button>

      {open && <div className="fold-body">{children}</div>}
    </div>
  )
}
